webpackJsonp([142629428675168],{

/***/ 341:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Web2Alpes - Assistance, conseil et sécurité informatique","description":"Societé de services informatique basée aux Deux Alpes dans l'Oisans proche de Grenoble : création de sites web, prestations PC, serveurs, réseaux et sécurité","keywords":"antoine meynet, web2alpes, web 2 alpes, web deux alpes,w2a, 2alpes-informatique, 2alpes informatique, 2 alpes informatique, deux alpes informatique, oisans informatique, oisans, 2alpes, 2 alpes, deux alpes, alpe d'huez, creation site internet, referencement site internet, site vitrine, e-boutique, e-commerce, react, site internet react, site internet wordpress, site internet e-commerce, site internet prestashop, maintenance informatique, assistance informatique, support informatique, hotspot wifi, hostspot, wifi, réseaux informatique, sécurité informatique, conseil informatique, consulting informatique, formation informatique, audit informatique"}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---index-9bdb77315303c9b73f07.js